import React, { useEffect, useState } from 'react';
import { Button, Checkbox, ControlLabel, FormGroup, Modal } from 'react-bootstrap';
import MultiPickList from '@nkr/components/multi-pick-list';
import useCenterListForOpo from '@nkr/store/center/hooks/use-center-list-for-opo';
import OpoDropDown from '@nkr/components/shared/opo-drop-down';
import useStrongBoxOpoCenter from '@nkr/store/strong-box-opo/hooks/use-strong-box-opo-center';
import { IAssignCenterOpoRequest } from '@nkr/models/strong-box';

interface IProps {
    show: boolean,
    initialOpoId?: string,
    onSave: () => void,
    onCancel: () => void
}

const AssignCenters = ({ show, initialOpoId, onSave, onCancel }: IProps) => {
    const [opoId, setOpoId] = useState<string>('');
    const [assignedCenters, setAssignedCenters] = useState<IAssignCenterOpoRequest[]>([]);
    const { list } = useCenterListForOpo();
    const { list: currentlyAssignedCenters, loading, saving, assignCenters } = useStrongBoxOpoCenter(opoId ? parseInt(opoId) : null);

    useEffect(() => {
        if (!show) {
            setOpoId('');
            setAssignedCenters([]);
        }
    }, [show]);

    useEffect(() => {
        if (initialOpoId) {
            setOpoId(initialOpoId);
        }
    }, [initialOpoId]);

    useEffect(() => {
        if (!opoId) {
            setAssignedCenters([]);
        }
    }, [opoId]);

    useEffect(() => {
        setAssignedCenters([...currentlyAssignedCenters]);
    }, [currentlyAssignedCenters]);

    const handleSubmit = async () => {
        await assignCenters(parseInt(opoId), assignedCenters);
        onSave();
    };

    const handleChange = (newList: IAssignCenterOpoRequest[]) => {
        setAssignedCenters(newList);
    };

    const myList = list.map(x => {
        return {
            id: x.id,
            description: x.alias
        };
    });

    return (
        <Modal backdrop='static' show={show} onHide={onCancel}>
            <Modal.Header closeButton>Assign Centers to OPO</Modal.Header>
            <Modal.Body>
                {loading && <div>Retrieving assigned centers...</div>}
                {saving && <div>Saving assigned centers...</div>}

                <FormGroup>
                    <ControlLabel>Select OPO</ControlLabel>
                    <OpoDropDown
                        unselectedText='- Select OPO -'
                        value={opoId}
                        className='form-control'
                        includeCenters={false}
                        onChange={setOpoId}
                    />
                </FormGroup>

                <MultiPickList
                    itemList={myList}
                    assignedList={assignedCenters}
                    getItemId={x => x.centerId}
                    createAssignedItem={id => ({ centerId: id, shipToOpo: false })}
                    renderItemHeader={
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'flex-end',
                                justifyContent: 'space-between',
                                padding: '2px 6px',
                                cursor: 'pointer',
                                borderBottom: '1px solid #ccc'
                            }}
                        >
                            <span style={{ width: '55%', fontWeight: 500 }}>Center</span>
                            <span style={{ width: '45%', fontWeight: 500, textAlign: 'center' }}>Ship SB to OPO</span>
                        </div>}
                    renderItemOptions={(item, onItemChange) =>
                        <Checkbox
                            style={{ marginTop: 0, marginBottom: 0 }}
                            checked={item.shipToOpo}
                            onChange={(e: React.FormEvent<Checkbox & HTMLInputElement>) => onItemChange({ ...item, shipToOpo: e.currentTarget.checked })}
                        />
                    }
                    availableLabel='Available Centers'
                    enableAvailableSearch={true}
                    availableSearchPlaceholder='Enter at least 3 characters...'
                    assignedLabel='Selected Centers'
                    enableAssignedSearch={true}
                    assignedSearchPlaceholder='Enter at least 3 characters...'
                    onChange={handleChange}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' disabled={!opoId} onClick={handleSubmit}>Save</Button>
                <Button onClick={onCancel}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default AssignCenters;
